<template>
	<div class="admin-layout">
		<header class="admin-layout__header">
			<img class="admin-layout__logo" draggable="false" :src="require('@/assets/svg/logo.svg')" />

			<nav class="admin-layout__menu menu">
				<router-link :to="{ name: 'AuthIndex' }" class="menu__item">Пользователи</router-link>
				<router-link :to="{ name: 'AdminImport' }" class="menu__item">Импортированные пользователи</router-link>
			</nav>

			<UserPanel class="admin-layout__user" @logout="onLogout" />
		</header>

		<div class="admin-layout__content">
			<router-view />
		</div>
	</div>
</template>

<script>
export default {
	name: "LayoutPanel",
	components: {
		UserPanel: () => import("../components/UserPanel")
	},
	methods: {
		onLogout() {
			this.$router.replace({ name: "AuthIndex" }).catch()

			// this.$router.replace({ name: "AuthLogin" }).catch()
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

.admin-layout {
	width: 100%;
	height: 100%;

	&__header {
		display: flex;
		justify-content: flex-start;
		padding: 10px 30px;
		background: white;
	}
	&__content {
		padding: 20px 30px;
	}
	&__logo {
		height: 50px;
	}

	.menu {
		display: flex;
		align-items: center;
		flex-grow: 1;
		padding-left: 40px;

		&__item {
			margin-right: 20px;

			&:last-child {
				margin-right: 0;
			}
		}
	}
}
</style>
